import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useCompanyFilter } from './useCompanyFilter';

export const CompanyFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, selected, options } = useCompanyFilter({
    setFilters,
    value,
  });

  return (
    <Formik initialValues={{ company: selected }} validationSchema={formSchema} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="company"
          placeholder="Search to add"
          size="small"
          component={FormSelect}
          defaultOptions={options}
          options={options}
          anchorToBody
          isSearchable
          isMulti={false}
          selectedOption={selected}
        />
      </Form>
    </Formik>
  );
};

CompanyFilter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setFilters: PropTypes.func.isRequired,
};

CompanyFilter.defaultProps = {
  value: null,
};
